/**
 * Formats a city slug into a proper city name
 * @param citySlug - The city slug from URL (e.g., "raleigh", "new-york")
 * @returns Formatted city name (e.g., "Raleigh", "New York")
 */
const formatCityFromSlug = (citySlug: string): string => {
    if (!citySlug) {
        return '';
    }

    return citySlug
        .split('-')
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join(' ');
};

/**
 * Creates a formatted location string for SEO pages
 * @param citySlug - The city slug from URL
 * @param region - The region/state abbreviation from URL
 * @param getStateName - Function to convert state abbreviation to full name
 * @returns Formatted location string (e.g., "in Raleigh, North Carolina") or empty string if no location
 */
export const formatLocationString = (
    citySlug?: string,
    region?: string,
    getStateName?: (state: string) => string
): string => {
    if (!citySlug && !region) {
        return '';
    }

    const locationParts: string[] = [];

    if (citySlug) {
        locationParts.push(formatCityFromSlug(citySlug));
    }

    if (region && getStateName) {
        locationParts.push(getStateName(region));
    }

    return locationParts.length > 0 ? `in ${locationParts.join(', ')}` : '';
};
